<template>
    <div class="layout">
        <menuBox :step="3"></menuBox>
        <div class="layout-home">
            <div class="projects-1">
                <p>Triển lãm</p>
                <div class="nav-menu">
                    <div class="">Trang chủ</div>
                    >
                    <div class="">Triển lãm</div>
                </div>
            </div>

            <div class="projects-2">
                <div class="title-text">cảm giác nghệ thuật bằng gỗ</div>
                <div class="title">Trưng bày nghệ thuật bằng gỗ nổi bật</div>
                <div class="sbtitle">Chúng tôi sẽ trưng bày một số tác phẩm nghệ thuật tinh tế đã đoạt giải thưởng và chúng tôi cũng sẽ tổ chức triển lãm ngoại tuyến trong tương lai</div>
                <img src="../assets/projects-2.png" alt="">
            </div>
            <footerBox></footerBox>
        </div>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="less" scoped>
.title-text {
    font-size: 16px;
    color: #3BA9F6;
    text-align: center;
}

.title {
    font-weight: 900;
    font-size: 28px;
    color: #333333;
    margin-top: 51px;
    text-align: center;
}

.sbtitle {
    font-size: 18px;
    color: #999999;
    margin-top: 48px;
    text-align: center;
}

.projects-1 {
    height: 355px;
    background: url('../assets/projects-1.png');
    background-size: 100% 100%;
    padding: 0px 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
        font-weight: 900;
        font-size: 72px;
        color: #3BA9F6;
    }

    .nav-menu {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #FFFFFF;
        margin-top: 16px;

        div {
            min-width: 94px;
            padding: 0px 20px;
            height: 43px;
            border-radius: 22px;
            border: 1px solid #FFFFFF;
            line-height: 43px;
            text-align: center;
            margin: 0px 10px;
        }
    }
}

.projects-2 {
    padding: 100px 0px;

    img {
        margin-top: 110px;
        width: 100%;
    }
}
</style>